<template>
  <div class="pepper-news" v-inview="{ callback: onInview }">
    <SectionLabel text="十大關鍵字 讀懂柱動態"/>
    <!-- background wave -->
    <div class="pepper-news__wave">
      <SvgSymbol use="#pepper-news-wave-blue"/>
    </div>
    <!-- chart -->
    <div class="pepper-news__chart">
      <div class="pepper-news__chart-loading" v-show="!tagsData.length"><SvgSymbol use="#spinner"/></div>
      <KeywordTagsChartD3 :keyword="keyword" :data="tagsData" v-if="tagsData.length"/>
    </div>
    <!-- guide -->
    <div class="pepper-news__guide">
      <span class="pepper-news__guide-text">資料說明：使用者於udn.com網站上，閱讀［洪秀柱］標籤的新聞後，再閱讀其他新聞的主要標籤關聯圖。</span>
      <span class="pepper-news__guide-text">資料起始：08/01/2019</span>
    </div>
    <!-- list -->
    <div class="pepper-news__list">
      <a class="pepper-news__item" v-for="news in newsData" :key="news.id" :href="news.url" :title="news.title" @click="onNewsItemClick" target="_blank">
        <div class="pepper-news__photo" :style="`background-image: url(${news.image || newsDefaultCover});`"></div>
        <div class="pepper-news__overview">
          <div class="pepper-news__datetime">{{ news.date }} {{ news.time }}</div>
          <div class="pepper-news__title">{{ news.title }}</div>
        </div>
      </a>
    </div>
    <!-- more -->
    <div class="pepper-news__more" @click="onMoreButtonClick">
      <OutlinesButton text="更多柱柱動態" link="https://udn.com/search/result/2/%E6%B4%AA%E7%A7%80%E6%9F%B1"/>
    </div>
  </div>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import OutlinesButton from '@/components/OutlinesButton'
// import KeywordTagsChart from '@/components/KeywordTagsChart'
import KeywordTagsChartD3 from '@/components/KeywordTagsChartD3'

const NEWS_DEFAULT_COVER = require('@/assets/news-default-cover.png')
const KEYWORD = '洪秀柱'
const TAG3D_API = 'https://udn.com/newmedia/active/chu/tag.php?date=today'
const KEYWORD_API = `https://misc.udn.com/service/udnplus_qword/${encodeURIComponent(KEYWORD)}`

export default {
  name: 'PepperNews',
  data () {
    return {
      newsDefaultCover: NEWS_DEFAULT_COVER,
      keyword: KEYWORD,
      newsData: [],
      tagsData: []
    }
  },
  components: {
    SectionLabel,
    OutlinesButton,
    // KeywordTagsChart,
    KeywordTagsChartD3
  },
  methods: {
    onInview () {
      console.log('PepperNews inview')
      this.fetch()
    },
    onDataLoaded ([ news, tags ]) {
      if (!news.data || !tags.data) {
        return
      }
      let newsData = this.processNews(news.data.item || [])
      let seedTags = newsData[0].tags.slice(0, 2)
      let tagsData = this.processTags(tags.data || [], seedTags)
      console.log(newsData)
      console.log(seedTags)
      console.log(tagsData)
      this.newsData = newsData
      this.tagsData = tagsData
    },
    onDataError (err) {
      console.warn(err)
    },
    processNews (arr) {
      let existIds = []
      // transform news data
      let allNews = arr
        .map(item => {
          let { entity = {}, info = {}, photoList = [], tagList = [] } = item
          let { headline: title } = entity
          let image = !photoList[0] ? '' : photoList[0].fileName
          let { articleId: id, postDate: datetime, url } = info
          let tags = tagList
            .filter(({ tagName }) => tagName !== this.keyword)
            .map(({ tagName }) => tagName)
          let [ date, time ] = datetime.split(' ')
          time = time.split(':').slice(0, 2).join(':')
          return { title, image, id, url, date, time, tags }
        })
      // filter duplicated and no tags news by id
      allNews
        .forEach((news, index, self) => {
          let { id, tags = [] } = news
          let existIndex = existIds.indexOf(id)
          if (existIndex !== -1) {
            (!tags.length ? news : self[existIndex]).duplicated = true
          }
          existIds.push(id)
        })
      existIds = null
      return allNews
        .filter(news => !news.duplicated)
        .slice(0, 4)
    },
    processTags (arr, seedTags = []) {
      return arr
        .filter(tag => {
          return (tag.tags !== this.keyword) && (!seedTags.some(tagName => tagName === tag.tags))
        })
        .slice(0, 10 - seedTags.length)
        .concat(
          seedTags
            .map((tagName, index) => {
              let exist = arr.find(tag => tag.tags === tagName)
              if (!exist) {
                exist = { tags: tagName, pid_cnt: 1, pid_pv: 1 }
              }
              return { ...exist, highlight: index }
            })
            .filter(tag => !!tag)
        )
        .map(tag => {
          let { tags: name, pid_cnt: amount, pid_pv: pageview, highlight = -1 } = tag
          return { name, amount, pageview, highlight }
        })
        .sort((a, b) => b.amount - a.amount)
    },
    // checkSimalarTags (tagA, tagB) {
    //   return (tagA.indexOf(tagB) !== -1) || (tagB.indexOf(tagA) !== -1)
    // },
    fetch () {
      Promise
        .all([
          this.$http.get(KEYWORD_API),
          this.$http.get(TAG3D_API)
        ])
        .then(this.onDataLoaded)
        .catch(this.onDataError)
    },
    onNewsItemClick () {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Read',
        'eventAction': 'Click',
        'eventLabel': 'Click_UDNnews'
      })
      console.log(`@${this.$options.name} [newsClick]`)
    },
    onMoreButtonClick () {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Read',
        'eventAction': 'Click',
        'eventLabel': 'Click_UDNSearch'
      })
      console.log(`@${this.$options.name} [moreButtonClick]`)
    }
  },
  mounted () {
    // this.fetch()
  }
}
</script>

<style lang="scss">
.pepper-news {
  $comp: &;
  @include use-layer(&);
  position: relative;
  min-height: 100vh;
  margin-top: -1px;

  .section-label {
    margin-bottom: -1px;
    background: #6a80d3;
  }

  &__wave {
    z-index: -1;
    position: relative;
    width: 100%;
    @include use-fixed-ratio(1111, 253);
    @include rwd($RWD_TABLET) {
      margin-top: -10px;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: -30px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: -80px;
    }

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &__chart {
    position: relative;
    max-width: 1360px;
    min-height: 300px;
    max-height: 650px;
    margin: -30px auto 0 auto;
    // background: #f1f1f1;
    // border: 1px dashed #1a1a1a;
    overflow: hidden;
    @include use-fixed-ratio(4, 3);
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: -45px;
    }
    @include rwd($RWD_TABLET) {
      margin-top: -55px;
    }
    @include rwd($RWD_DESKTOP) {
      margin-top: -70px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: -100px;
    }

    // &:after {
    //   content: "force-chart";
    //   display: block;
    //   position: absolute;
    //   top: 10px;
    //   left: 10px;
    // }

    &-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 60px;
      height: 60px;
      color: #e4007f;
      transform: translate(-50%, -50%);
    }

    .keyword-tags-chart {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__guide {
    margin: 0 22px;
    color: #1a1a1a;
    // line-height: 1.875em;
    text-align: justify;
    text-justify: inter-word;
    @include rwd($RWD_TABLET_SMALL) {
      width: 90%;
      max-width: 600px;
      margin: 0 auto;
    }
    @include rwd($RWD_DESKTOP) {
      max-width: 780px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      // width: auto;
    }
  }

  &__guide-text {
    display: block;
    font-size: 0.875em;
    font-weight: bold;
    line-height: 2.143em;
    @include rwd($RWD_DESKTOP) {
      font-size: 1em;
      line-break: 1.875em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      // text-align: center;
    }
  }

  &__list {
    margin-top: 60px;
    padding: 0 10px;

    @include rwd($RWD_TABLET_SMALL) {
      width: 520px;
      margin: 63px auto 0 auto;
      padding: 0;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 67px;
      padding: 0 42px 0 0;
    }
    @include rwd($RWD_DESKTOP) {
      width: 850px;
      margin-top: 80px;
      padding: 0;
      padding: 0 60px 0 0;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 1290px;
      margin-top: 120px;
      padding: 0 105px 0 0;
    }
  }

  &__item {
    display: block;
    position: relative;
    color: #1a1a1a;
    @include use-vertical-align();
    @include rwd($RWD_TABLET) {
      display: inline-block;
      width: 50%;
      vertical-align: top;
      @include use-vertical-align(none);
    }
    @include rwd($RWD_DESKTOP) {
      width: 25%;
    }

    &:active {
      color: #e4007f;
    }

    &:nth-child(2n) {
      @include rwd($RWD_TABLET) {
        right: -42px;
      }
      @include rwd($RWD_DESKTOP) {
        right: auto;
      }
    }

    & + & {
      margin-top: 30px;
      @include rwd($RWD_TABLET) {
        margin-top: 0;
      }
      @include rwd($RWD_DESKTOP) {
        right: -20px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        right: -35px;
      }
    }
    & + & + & {
      @include rwd($RWD_TABLET) {
        margin-top: 44px;
      }
      @include rwd($RWD_DESKTOP) {
        right: -40px;
        margin-top: 0;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        right: -70px;
      }
    }
    & + & + & + & {
      @include rwd($RWD_DESKTOP) {
        right: -60px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        right: -105px;
      }
    }
  }

  &__photo {
    display: inline-block;
    width: 37.5%;
    vertical-align: top;
    background: #f1f1f1 no-repeat top center / cover;
    @include use-fixed-ratio(4, 3);

    @include rwd($RWD_TABLET_SMALL) {
      width: 34.62%;
    }
    @include rwd($RWD_TABLET) {
      display: block;
      width: auto;
    }
  }

  &__overview {
    display: inline-block;
    width: 62.5%;
    padding: 0 0 0 10px;
    vertical-align: top;
    @include rwd($RWD_TABLET_SMALL) {
      width: 65.38%;
      padding: 0 0 0 15px;
    }
    @include rwd($RWD_TABLET) {
      display: block;
      width: auto;
      padding: 0;
    }
  }

  &__datetime {
    font-size: 0.875em;
    font-weight: 500;
    line-height: 1em;
    letter-spacing: 0.1em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1em;
    }
    @include rwd($RWD_TABLET) {
      display: block;
      margin-top: 23px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 33px;
    }
  }

  &__title {
    margin-top: 13px;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.5em;
    letter-spacing: 0.1em;
    text-align: justify;
    text-justify: inter-word;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 10px;
    }
  }

  &__more {
    padding: 55px 0 70px 0;
    text-align: center;
    @include rwd($RWD_DESKTOP_WIDE) {
      padding: 55px 0 120px 0;
    }
  }

  .outlines-button {
    width: 200px;
    height: 45px;
  }
}

.desktop {
  .pepper-news {
    $comp: ".pepper-news";
    #{$comp}__item {
      &:hover {
        color: #e4007f;
      }
      &:active {
        color: #e4007f;
        transform: translateY(2px);
      }
    }
  }
}
</style>
